<div class="alert-container" [class]="alertContents.Class">
    <div class="alert-icon">
        <img [src]="icon" alt="primary card" style="width: 32px;">
    </div>

    <div class="alert-content">
        <h2 class="fw-bold text-black">{{alertContents.Header}}</h2>
        <ul>
            <li *ngFor="let alert of alertContents.Data">
                <p>{{ isLeft ? alert.ContentEn : alert.ContentAr }}</p> 
                <div class="alert-actions">
                    <button [disabled]="!alert.IsActive" (click)="onClick(alert)" class="button button-primary">
                        <span>{{ isLeft ? alert.ActionTitleEn : alert.ActionTitleAr }}</span>
                    </button> 
                </div>
            </li>
        </ul>
    </div>
</div>